import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { Provider as ReduxProvider } from "react-redux";
import { store } from "./redux/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles/tailwind.css";
import "./styles/index.css";
import "../locales/i18n";
import "react-loading-skeleton/dist/skeleton.css";
const container = document.getElementById("root");
const root = createRoot(container);
import { LanguageProvider } from "./contexts/LanguageContext";
root.render(
  <ReduxProvider store={store}>
    <LanguageProvider>
      <App />
    </LanguageProvider>
    <ToastContainer />
  </ReduxProvider>
);
